import { render } from "./MaterialAlmacenForm.vue?vue&type=template&id=b43f1ff4&scoped=true"
import script from "./MaterialAlmacenForm.vue?vue&type=script&lang=js"
export * from "./MaterialAlmacenForm.vue?vue&type=script&lang=js"

import "./MaterialAlmacenForm.vue?vue&type=style&index=0&id=b43f1ff4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b43f1ff4"]])

export default __exports__